
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { AfterViewInit, Component, ViewChild, ViewContainerRef } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';
import * as _ from 'lodash';

@Component({
  selector:'custom-multiselect',
  template : `<ng-select id="ddlMulti"
  [items]="items"
  [multiple]=true
  [searchable]="true"
  [searchFn]="onNGSearch" 
  [closeOnSelect]=false
  [markFirst]="true"
  [isOpen]="true"
  [(ngModel)]="selectedItems">
</ng-select>`,
  styles:[
    `
      `
  ]

})
export class MultiSelectComponent implements ICellRendererAngularComp,AfterViewInit   {
  refresh(params: ICellRendererParams<any, any, any>): boolean {
    throw new Error('Method not implemented.');
  }
  public items: any;
  public selectedItems: Array<any>;
  private params: any;
  public value: any;

  @ViewChild('selector', { read: ViewContainerRef }) public select : any;

  agInit(params: any): void {
    this.params = params;
    if (this.params.dataSourceType == "years") {
      this.items = params.values
    }
    else {
      let type: any[] = [];
      if(params.data.crop === params.context.componentParent.selectedCrop.Name)
        type = params.data.type === 'Program(s)' ?  params.context.componentParent.programs : params.data.type === 'Region(s)' ?  params.context.componentParent.regions :  params.context.componentParent.ezs;   
      else
        type = params.data.type === 'Program(s)' ?  params.context.componentParent.pStagePrograms : params.data.type === 'Region(s)' ?  params.context.componentParent.pStageRegions :  params.context.componentParent.pStageEzs;        
      this.items = type.map(e => e.code ? e.code : e.Code);
    }
      
    this.selectedItems = new Array<any>();
    if (!(_.isNil(params.value) || params.value === "")) {
      let items = params.value;
      if (!Array.isArray(items) && this.params.separator)
        items = items.split(this.params.separator);
      
      items.forEach((item: any) => {
        this.selectedItems.push(item);
      });
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      const ddl = document.getElementById("ddlMulti");
      const inputBox = ddl?.firstChild?.firstChild?.lastChild?.firstChild as HTMLElement;
      if (inputBox)
        inputBox.focus();
    }, 200);
  }

  public isPopup(): boolean {
    return true;
  }

  public getValue(): any {
    if (this.params.separator)
      return this.selectedItems && this.selectedItems.length > 0 ? this.selectedItems.join(this.params.separator) : '';
    return this.selectedItems;
  }

  onNGSearch(word: string, item: string): boolean {
    return item.toLocaleLowerCase().startsWith(word.toLocaleLowerCase());
  }
}
